import React from 'react'

import { Loading, SIZES } from 'components/loading/component'
import { Logo } from 'components/images/logo'
import 'components/styles/main.scss'

import { AuthenticationStatus, logout, validateRequest } from '../../services/auth'
import { Login } from '../auth/login'
import { Button } from 'reactstrap'

interface State {
  authenticated: AuthenticationStatus,
  validating: boolean,
}

const initialState: State = {
  authenticated: AuthenticationStatus.INVALID_TOKEN,
  validating: true,
}

export const AuthenticatedDashboard = (props) => {
  const [state, setState] = React.useState(initialState)

  React.useEffect(() => {
    void validateAuthToken()
  }, [])

  const validateAuthToken = () => {
    validateRequest()
      .then((isAuthenticated: AuthenticationStatus) => {
        setState({
          ...state,
          authenticated: isAuthenticated,
          validating: false,
        })
      })
  }

  const clearTokenAndNavigateToLogin = (e) => {
    e.preventDefault()
    logout()
    validateAuthToken()
  }

  if (state.validating) {
    return (
      <div className="main">
        <Loading size={SIZES.LARGE} withLogo={true}/>
      </div>
    )
  } else {
    switch (state.authenticated) {
      case AuthenticationStatus.NO_COMMUNITY:
        return <div className="main"><Logo/></div>
      case AuthenticationStatus.NO_ACCESS:
        return <div className="main">
          <Logo/>
          <h1>The account you have logged in with does not have access to this page.</h1>
          <p>
            Click <Button className="auth-text-link" onClick={clearTokenAndNavigateToLogin}>here</Button> to login again.
          </p>
        </div>
      case AuthenticationStatus.INVALID_TOKEN:
        return <div className="main">
          <Logo/>
          <h1>There was a problem with your login credentials.</h1>
          <p>
            Click <Button className="auth-text-link" onClick={clearTokenAndNavigateToLogin}>here</Button> to login again.
          </p>
        </div>
      case AuthenticationStatus.VALID:
        return <div className="main">{props.children}</div>
      case AuthenticationStatus.NO_TOKEN:
        return <Login loginSuccessCallback={validateAuthToken} />
      default:
        return null
    }
  }
}
